export const getHearingDate = (tipsheet) => {
  const dateSegments = tipsheet.tile_date.split('-');
  return new Date(dateSegments[0], Number(dateSegments[1]) - 1, dateSegments[2]);
};

export const isWithinLastXDays = (days, dateString) => {
  const [year, month, day] = dateString.split("-").map(Number);
  let date = new Date(year, month - 1, day);
  const xDaysAgo = new Date();
  xDaysAgo.setDate(xDaysAgo.getDate() - days);
  return date >= xDaysAgo;
};

export const isExcluded = (tile, exclusionsList) => {
  if (exclusionsList.length === 0) return false;
  return ((exclusionsList.includes("appropriations") && tile.tile_committee?.toLowerCase().includes("committee on appropriations"))
    || ((exclusionsList.includes("zero")) && tile.tipsheet_tile_json?.score === 0));
};
